"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PurchaseType;
(function (PurchaseType) {
    PurchaseType["smartphone"] = "smartphone";
    PurchaseType["tablet"] = "tablet";
    PurchaseType["computer"] = "computer";
    PurchaseType["laptop"] = "laptop";
    PurchaseType["tv"] = "tv";
    PurchaseType["fossilFuelCar"] = "fossilFuelCar";
    PurchaseType["hybridCar"] = "hybridCar";
    PurchaseType["eletricCar"] = "eletricCar";
    PurchaseType["cryptoCurrencyPoW"] = "cryptoCurrencyPoW";
    PurchaseType["singleEditionNFT"] = "singleEditionNFT";
})(PurchaseType = exports.PurchaseType || (exports.PurchaseType = {}));
